import React from 'react';
import { Avatar } from '@saleshandy/design-system';
import { DoNotCallList } from '../../../../../../../types/do-not-call-list';
import { OverlayTooltip } from '../../../../../../../../../shared/design-system/components/overlay';

type IProps = {
  doNotCallList: DoNotCallList;
};

const AddedByField: React.FC<IProps> = ({ doNotCallList: { user } }) => {
  const fullName = user ? `${user.firstName} ${user.lastName}`.trim() : '';
  return (
    <div className="added-by-field">
      <OverlayTooltip text={fullName || user?.email || ''}>
        <Avatar firstName={user?.firstName || ''} lastName={user?.lastName || ''} />
      </OverlayTooltip>
    </div>
  );
};

export default AddedByField;
